/**
 * @desc 根据PO-sku查询SN
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export type Response = defs.srm.ResponseDto<Array<defs.srm.SupplierSnResponseDto>>;
export function request(pono: string, sku: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/srm/supplierSn/getSnByPoSKu/${pono}/${sku}`, {
      method: "GET",

      ...options,
    }),
  );
}
